<template>
  <v-row>

    <v-col>
      <v-sheet
        outlined
        v-if="!loading">
        
        <!-- Imagen para pantallas pequeñas (xs) -->
        <v-img
          class="image-landing"
          height="80"
          v-if="$vuetify.breakpoint.xsOnly && waiting_room_sm_image"
          :src="waiting_room_sm_image"
          max-height="80px"
        ></v-img>

        <!-- Imagen para pantallas medianas y grandes (md y superiores) -->
        <v-img
          class="image-landing"
          height="120"
          v-if="!$vuetify.breakpoint.xsOnly && waiting_room_image"
          :src="waiting_room_image"
          max-height="120px"
        ></v-img>

        <v-row class="pa-6">
          <v-container style="max-width: 75vw;">
            <v-col cols="12">
              <h2 class="pt-8">
                ¡Hola <b>{{ user.name }}!</b>
              </h2>
              <h3 class="pt-4">
                ¡Te esperamos a partir del {{ handleDate(edition.edition.start_date_public_access) }} 
                para disfrutar de la {{ edition.edition.name + ' - '+ edition.edition.short_name }}!
              </h3>
              <h3>
                Saludos. <br>
                Equipo JIJE
              </h3>
            </v-col>

            <v-col cols="12" class=" pt-8 text-center"  v-if="!loading">
              <v-btn
                x-large
                class="white--text"
                color="#0097B4"
                @click="changeEdition()">
                Recorrer otra Edición
              </v-btn>
            </v-col>
          </v-container>
        </v-row>
      </v-sheet>
    </v-col>

    <v-dialog
      v-model="change_edition"
      max-width="600px">
      <v-card :loading="loading_btn">
        <v-card-title>
          <span class="text-h5">Seleccione una edición:</span>
        </v-card-title>
        <v-card-text>

          <v-col cols="12">
            <v-btn 
              v-for="edition in editions"
              :key="edition.id"
              block
              x-large
              dark
              color="#0097B4"
              class="mt-4"
              @click="setEdition(edition.slug)">
              {{ edition.short_name }}
            </v-btn>
          </v-col>
 
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="isLoading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  const APP_URL = process.env.VUE_APP_URL
  import { mapGetters } from 'vuex'
  import axios from 'axios'

  export default {
    name: 'homeWaitingRoom',
    data: () => ({
      loading: true,
      loading_btn:false,
      loading_get_editions: false,
      dialog:false,
      edition_id:null,
      editions: null,
      slug: null,
      edition2: null,
      change_edition:false,

      waiting_room_image: null,
      waiting_room_sm_image: null
    }),

    computed: {
      ...mapGetters([ 
      'isLogged','user', 'edition'
      ]),
      isLoading() {
        return this.loading || this.loading_get_editions;
      }
    },

    methods:{
      setData(){
        if(this.edition.edition.edition_customization.waiting_room_image!=null){
          this.waiting_room_image = APP_URL + this.edition.edition.edition_customization.waiting_room_image
        }

        if(this.edition.edition.edition_customization.waiting_room_sm_image!=null){
          this.waiting_room_sm_image = APP_URL + this.edition.edition.edition_customization.waiting_room_sm_image
        }
      },

      handleDate(fecha) {
          var partes = fecha.split('-'); // Dividir la fecha en partes [año, mes, día]
          var nuevaFecha = partes[2] + '/' + partes[1] + '/' + partes[0];
          return nuevaFecha;
      },

      async getInfoEdition(){
        await axios.get('edition/'+this.edition.edition.slug+'/slug').then(response => {
          this.edition2 = response.data.data.edition
          if(this.edition2.access_enabled){
            this.logout()
            this.$router.push({ name: 'login' })
          }
          // localStorage.removeItem('user')
          this.$store.dispatch('setDrawer', true);
          this.loading = false
        }).catch((e)=>{
          console.log(e)
        })
      },

      async changeEdition(){
        this.loading_get_editions = true
        await axios.get('edition').then(response => {
          this.editions = response.data.data.editions
          this.loading_get_editions = false
          this.change_edition = true
        })
      },

      async setEdition(slug){
        this.loading_btn=true
        this.$store.dispatch('setDrawer', false);
        localStorage.removeItem('convocation_form')
        localStorage.removeItem('edition')
        await axios.get('change-edition/'+slug).then(response => {
          this.data = response.data.data

          this.appbar_dark_mode = (this.data.edition.edition_customization.appbar_dark_mode)?true:false
          this.appbar_image = APP_URL + this.data.edition.edition_customization.appbar_image

          this.loading = false
          
          localStorage.setItem('edition_id', this.data.edition_id);
          localStorage.setItem('edition', this.data.edition);
          localStorage.setItem('convocation_form', this.data.convocation_form);

          this.$store
                .dispatch('edition', {
                  edition: this.data.edition 
                })

          this.$store
                .dispatch('convocationForm', {
                  convocation_form: this.data.convocation_form
                })

          if(this.$route.name!='home'){
            this.$router.push({ name: 'home'})
          }
          this.loading_btn=false
          this.change_edition = false
        })
      }
    },

    created(){
      this.setData(),
      this.$store.dispatch('setDrawer', true);
      this.loading=false
    },
  }
</script>